/* eslint-disable @typescript-eslint/naming-convention */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Size } from '@ansys-internal/awc-angular/core';
import { SectionCardTab } from './types/section-card-tab.type';
import { ConceptSubSection } from 'src/app/shared/enums/concept.enum';
import { DashboardPanelComponent } from '@ansys-internal/awf-angular/dashboard';
import { IconComponent } from '@ansys-internal/awc-angular/icons';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'section-card',
    templateUrl: './section-card.component.html',
    styleUrls: ['./section-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [DashboardPanelComponent, IconComponent, CommonModule, SharedModule]
})
export class SectionCardComponent {
  @Input() selectedSectionId: string = '';
  @Input() sections: SectionCardTab[] = [];
  @Output() selectedSectionIdChange: EventEmitter<ConceptSubSection> =
    new EventEmitter<ConceptSubSection>();
  protected readonly Size = Size;
  constructor(private _cdr: ChangeDetectorRef) {}

  protected selectSection(sectionId: string): void {
    this.selectedSectionId = sectionId;
    this.selectedSectionIdChange.emit(sectionId as ConceptSubSection);
  }
}
